import { render, staticRenderFns } from "./DeviceMockup.vue?vue&type=template&id=5f2fe461&scoped=true&"
import script from "./DeviceMockup.vue?vue&type=script&lang=ts&"
export * from "./DeviceMockup.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceMockup.vue?vue&type=style&index=0&id=5f2fe461&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fe461",
  null
  
)

export default component.exports